import React from 'react'
import ReactDOM from 'react-dom'
import { ThemeProvider } from '@material-ui/styles'
import { CssBaseline } from '@material-ui/core'


import Themes from './themes'
import App from './components/App'
import * as serviceWorker from './serviceWorker'
import { LayoutProvider } from './context/LayoutContext'
import { UserProvider } from './context/UserContext'
import { LoadingProvider } from './context/LoadingContext'
import { MasterProvider } from './context/MasterContext'
import { CompanyProvider } from './context/CompanyContext'

ReactDOM.render(
	<LayoutProvider>
		<UserProvider>
			<LoadingProvider>
				<MasterProvider>
					<CompanyProvider>
						<ThemeProvider theme={Themes.default}>
							<CssBaseline />
							<App />
						</ThemeProvider>
					</CompanyProvider>
				</MasterProvider>
			</LoadingProvider>
		</UserProvider>
	</LayoutProvider>,
	document.getElementById('root'),
)

var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
(function(){
var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
s1.async=true;
s1.src='https://embed.tawk.to/5e1ae3a57e39ea1242a434ba/default';
s1.charset='UTF-8';
s1.setAttribute('crossorigin','*');
s0.parentNode.insertBefore(s1,s0);
})();


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister()
